var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadarrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 261.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1954.88,
    y1: -449.52,
    x2: 1979,
    y2: -495.6,
    gradientTransform: "translate(-852.4 -919.12) rotate(43.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00bfa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#008bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1965.43,
    y1: -507.86,
    x2: 1971.01,
    y2: -507.86,
    gradientTransform: "translate(-852.4 -919.12) rotate(43.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00bfa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1971.01,
    y1: -508.37,
    x2: 1974.71,
    y2: -508.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1976.04,
    y1: -508.49,
    x2: 1979.9,
    y2: -508.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1974.71,
    y1: -508.5,
    x2: 1976.04,
    y2: -508.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1965.43,
    y1: -507.99,
    x2: 1979.9,
    y2: -507.99,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1945.24,
    y1: -452.89,
    x2: 1978.75,
    y2: -516.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1935.57,
    y1: -456.29,
    x2: 1978.55,
    y2: -538.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1925.87,
    y1: -459.68,
    x2: 1978.35,
    y2: -559.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1916.17,
    y1: -463.11,
    x2: 1978.14,
    y2: -581.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 717.18,
    y1: 294.41,
    x2: 918.95,
    y2: 92.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,156.77q0-28.7,17.62-44.45T66.44,96.57q19.66,0,32,5.45t12.32,16.69a20,20,0,0,1-3,10.3q-3,5-4.84,6.24a84.89,84.89,0,0,0-13.1-4.68,65.9,65.9,0,0,0-17.78-2.19q-36.5,0-36.5,38.69v90.46H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.65,256.91q-3.12.61-9.83,1.4t-15.75,1.56q-9,.78-20.28,1.4t-23.4.63q-24.33,0-39.77-4.21t-24.33-11.23q-8.89-7-12.16-16.23a55.68,55.68,0,0,1-3.28-18.87,59.79,59.79,0,0,1,3.9-22.46,37.22,37.22,0,0,1,12.79-16.22q8.9-6.56,23.24-9.83t34.94-3.27q11.85,0,22.46.78t15.91,1.4q0-10.92-3.59-18.09a28,28,0,0,0-9.83-11.23,40.36,40.36,0,0,0-15-5.62,111.4,111.4,0,0,0-19.34-1.56q-17.79,0-28.55,4.06t-14.19,6.86a38.22,38.22,0,0,1-5.15-5.92,17.2,17.2,0,0,1-3.27-10.61,17.49,17.49,0,0,1,2.34-8.58q2.34-4.21,8.26-7.49t15.91-5.14A140.84,140.84,0,0,1,185,96.57a145.65,145.65,0,0,1,33.54,3.58,73.61,73.61,0,0,1,26,11.39,52.4,52.4,0,0,1,17,20.59q6.09,12.8,6.09,30.88ZM232.4,187.65q-3.12-.61-11.7-1.87T195,184.53q-21.21,0-30.88,6.4t-9.67,20.12a25.47,25.47,0,0,0,2,10.29,18.24,18.24,0,0,0,7,8q5,3.27,13.57,5A111.65,111.65,0,0,0,198.39,236a185.59,185.59,0,0,0,22.78-1.1q8.42-1.08,11.23-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.1,44.16q0-8.43,4.84-12.48t13.88-4.05A35.56,35.56,0,0,1,460.11,29q4.68,1.39,6.24,2V171.74q0,22.78-6.39,39.62t-17.63,28.08a72.35,72.35,0,0,1-26.51,16.84,96,96,0,0,1-33.38,5.62,89.48,89.48,0,0,1-33.85-6.24,81.76,81.76,0,0,1-26.67-17.16,78,78,0,0,1-17.63-26.2,84.86,84.86,0,0,1-6.39-33.07A88.38,88.38,0,0,1,304,146a79.83,79.83,0,0,1,16.85-26.2,75.55,75.55,0,0,1,25.27-17.16,81,81,0,0,1,31.66-6.08q18.09,0,31.82,7t21.52,17Zm0,135.07a55.31,55.31,0,0,0-3.59-20,50.8,50.8,0,0,0-9.82-16.22,44.18,44.18,0,0,0-15.13-10.77,51.08,51.08,0,0,0-39.15,0,47.4,47.4,0,0,0-15.13,10.61A45.94,45.94,0,0,0,338.45,159,58.42,58.42,0,0,0,335,179.23a57.08,57.08,0,0,0,3.43,20.12,46.12,46.12,0,0,0,9.83,15.91,47.09,47.09,0,0,0,15.13,10.61,47.67,47.67,0,0,0,19.65,3.9,49.69,49.69,0,0,0,19.5-3.75,44.23,44.23,0,0,0,15.13-10.29,47.26,47.26,0,0,0,9.82-15.91A57.11,57.11,0,0,0,431.1,179.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M640.11,256.91q-3.12.61-9.83,1.4t-15.75,1.56q-9,.78-20.28,1.4t-23.39.63q-24.35,0-39.78-4.21t-24.33-11.23q-8.89-7-12.16-16.23a55.68,55.68,0,0,1-3.28-18.87,59.79,59.79,0,0,1,3.9-22.46A37.22,37.22,0,0,1,508,172.68q8.89-6.56,23.24-9.83t34.94-3.27q11.85,0,22.46.78t15.91,1.4q0-10.92-3.59-18.09a28,28,0,0,0-9.83-11.23,40.36,40.36,0,0,0-15-5.62,111.4,111.4,0,0,0-19.34-1.56q-17.79,0-28.55,4.06t-14.19,6.86a38.22,38.22,0,0,1-5.15-5.92,17.2,17.2,0,0,1-3.27-10.61,17.49,17.49,0,0,1,2.34-8.58q2.34-4.21,8.26-7.49t15.91-5.14a140.84,140.84,0,0,1,25.27-1.87A145.65,145.65,0,0,1,591,100.15a73.61,73.61,0,0,1,26,11.39,52.4,52.4,0,0,1,17,20.59q6.09,12.8,6.09,30.88Zm-35.25-69.26q-3.12-.61-11.7-1.87t-25.74-1.25q-21.21,0-30.88,6.4t-9.67,20.12a25.47,25.47,0,0,0,2,10.29,18.24,18.24,0,0,0,7,8q5,3.27,13.57,5A111.69,111.69,0,0,0,570.86,236a185.52,185.52,0,0,0,22.77-1.1q8.42-1.08,11.23-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M676.6,156.77q0-28.7,17.63-44.45t48.82-15.75q19.65,0,32,5.45t12.32,16.69a20,20,0,0,1-3,10.3q-3,5-4.84,6.24a84.51,84.51,0,0,0-13.1-4.68,65.85,65.85,0,0,0-17.78-2.19q-36.49,0-36.5,38.69v90.46H676.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M929.94,105.55a36.14,36.14,0,0,0-8.59-17c-.75-.86-1.58-1.7-2.43-2.51a42.28,42.28,0,0,0-13.41-8.56,41.66,41.66,0,0,0-19.13-2.85,36.16,36.16,0,0,0-17.9,6.39,2,2,0,0,0-.66,2.44,1.74,1.74,0,0,0,.44.67,2,2,0,0,0,1.78.52,63.54,63.54,0,0,1,16.45-1.18A50.3,50.3,0,0,1,915.18,95c1,.79,1.9,1.64,2.83,2.52a67.55,67.55,0,0,1,8.3,9.65c.08.1.17.18.25.27a2,2,0,0,0,3.38-1.85ZM919.42,96q1.73,1.64,3.35,3.43Q921.15,97.66,919.42,96Zm3.39,3.47c1.08,1.19,2.11,2.43,3.12,3.75C924.92,102,923.87,100.71,922.81,99.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M921.68,67.32a55.45,55.45,0,0,1,4.61,3.26C924.8,69.41,923.26,68.34,921.68,67.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M929.12,73c-.92-.82-1.86-1.63-2.83-2.39C927.25,71.35,928.19,72.15,929.12,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M932.86,76.57c-.88-.94-1.81-1.83-2.75-2.71l.44.41C931.33,75,932.11,75.77,932.86,76.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M930.11,73.86l-1-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M930.55,74.27l-.44-.41c.94.88,1.87,1.77,2.75,2.71C932.11,75.77,931.33,75,930.55,74.27ZM929.12,73l1,.89Zm-2.83-2.39c1,.76,1.91,1.57,2.83,2.39C928.19,72.15,927.25,71.35,926.29,70.58Zm0,0a55.45,55.45,0,0,0-4.61-3.26C923.26,68.34,924.8,69.41,926.29,70.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M947.4,97.85a56.09,56.09,0,0,0-13.07-22.68c-.77-.81-1.58-1.6-2.38-2.37A61.59,61.59,0,0,0,886.19,56a56.13,56.13,0,0,0-25.08,7.44,2.05,2.05,0,0,0-.84,2.55,2.16,2.16,0,0,0,.48.68,2.06,2.06,0,0,0,1.94.48,76.27,76.27,0,0,1,23.6-3.09A67.28,67.28,0,0,1,928.7,81c.6.54,1.22,1.1,1.8,1.66a77.55,77.55,0,0,1,13.21,16.8,2.73,2.73,0,0,0,.36.45,2,2,0,0,0,3.33-2Zm-17.29-24-1-.89Zm-3.82-3.28c-1.49-1.17-3-2.24-4.61-3.26A55.45,55.45,0,0,1,926.29,70.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M964.87,90.22A76.15,76.15,0,0,0,947.3,61.79c-.75-.77-1.54-1.55-2.33-2.31a81.33,81.33,0,0,0-59-22.12,76.07,76.07,0,0,0-32.3,8.54,2,2,0,0,0-.92,2.58,1.86,1.86,0,0,0,.46.67,2,2,0,0,0,2,.46,91.3,91.3,0,0,1,30.83-5A85,85,0,0,1,942.25,67l1,1a92.21,92.21,0,0,1,17.93,23.89,1.71,1.71,0,0,0,.38.53,2,2,0,0,0,3.31-2.13ZM946.63,68.48c.6.6,1.21,1.19,1.79,1.82C947.84,69.67,947.23,69.08,946.63,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M981.28,85.21a2,2,0,0,1-2.2-.39,2.37,2.37,0,0,1-.43-.57A107.17,107.17,0,0,0,956.2,53.4l-.39-.36a101.11,101.11,0,0,0-15.23-11.83,99.35,99.35,0,0,0-17.11-8.76A100.83,100.83,0,0,0,905,27a102.21,102.21,0,0,0-19.16-1.88,107.08,107.08,0,0,0-38,6.93,2,2,0,0,1-2.11-.42,2.11,2.11,0,0,1-.48-.67,2,2,0,0,1,1-2.62,97.46,97.46,0,0,1,39.55-9.66,100.35,100.35,0,0,1,20.55,1.5,101,101,0,0,1,38.1,15.19,101.86,101.86,0,0,1,13.76,10.9c.73.7,1.45,1.41,2.14,2.12a97.24,97.24,0,0,1,22.07,34.22A2,2,0,0,1,981.28,85.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M998.82,77.67a2.06,2.06,0,0,1-2.25-.38,2.3,2.3,0,0,1-.43-.57l-2.56-5.24c-.35-.66-.72-1.32-1.08-2-.57-1-1.15-2.12-1.7-3.09-.37-.61-.72-1.22-1.09-1.82-.64-1.06-1.29-2.15-1.93-3.15-.4-.57-.79-1.17-1.17-1.76-.7-1-1.39-2.07-2.13-3.08a121.25,121.25,0,0,0-15.12-17.5l-.22-.21A120.68,120.68,0,0,0,885.59,5.69a123.52,123.52,0,0,0-23,2.28c-1.24.25-2.45.52-3.66.8l-2,.45-3.64,1c-.68.19-1.35.36-2,.54-1.14.34-2.29.73-3.42,1.1l-2.1.68-5.55,2.05a2,2,0,0,1-2.1-.44,1.9,1.9,0,0,1-.48-.7,2,2,0,0,1,1.07-2.62l5.44-2.34.11,0L846,7.79c1.28-.49,2.57-1,3.93-1.43l2-.64c1.24-.39,2.49-.79,3.8-1.17l2-.52c1.25-.35,2.52-.68,3.8-1a119.95,119.95,0,0,1,48.14-1.1A120.44,120.44,0,0,1,954.49,19.8a120.58,120.58,0,0,1,16.87,13.33c.66.63,1.31,1.27,1.94,1.9a117.63,117.63,0,0,1,15.36,18.71c.72,1.07,1.39,2.18,2.09,3.3l1.12,1.82c.66,1.12,1.27,2.27,1.9,3.4l1,1.88c.62,1.23,1.22,2.44,1.82,3.66l.83,1.68a.24.24,0,0,0,0,.1L999.84,75A2,2,0,0,1,998.82,77.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M800.13,156.77q0-28.7,17.63-44.45t48.81-15.75q19.66,0,32,5.45t12.32,16.69a20,20,0,0,1-3,10.3q-3,5-4.84,6.24a84.51,84.51,0,0,0-13.1-4.68,65.85,65.85,0,0,0-17.78-2.19q-36.5,0-36.5,38.69v90.46H800.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarrLogo);
export default __webpack_public_path__ + "static/media/radarr-logo.7b61b6d90cfff3ada3aa0ad4499db072.svg";
export { ForwardRef as ReactComponent };